export default "__VITE_ASSET__46097c3a__"